
const state = () => ({
  /**
   * The returned timeoutID which identifies the timer.
   * @type Number
   */
  timmer: null,

  /**
   * Determine if the loader is working (implies that the content is loading).
   * @type Boolean
   */
  isLoading: false,

  /**
   * Determine the visibility of the loader.
   * @type Boolean
   */
  show: false,
})

const getters = {}

const mutations = {
  _start (state) {
    state.isLoading = true
  },
  _show (state) {
    state.show = true
  },
  _setTimmer (state, v) {
    state.timmer = v
  },
  stop (state) {
    state.isLoading = false
    state.show = false
    clearTimeout(state.timmer)
  },
}

const actions = {
  start ({ commit }, delay) {
    commit('_start')
    commit('_setTimmer', setTimeout(() => commit('_show'), delay))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
